import { ManageFoldersTabController } from './manage-folders-tab-access.controller'

function manageFoldersTabAccess () {
  return {
    restrict: 'E',
    scope: {
      folders: '<',
      form: '=',
      flags: '='
    },
    templateUrl: '/repository/directives/manage-folders-tab-access/manage-folders-tab-access-directive.html?$$REVISION$$',
    controller: ManageFoldersTabController
  }
}

export { manageFoldersTabAccess }
